document.addEventListener('DOMContentLoaded', function () {
    const allImages = document.querySelectorAll(".article-template__content > div > img");
    allImages.forEach(image => {
        const alt = image.getAttribute("alt");
        if (alt === "" || !alt) return;
        const altNode = document.createElement("span");
        altNode.classList.add("image-caption");
        altNode.innerHTML = alt
        image.parentNode.append(altNode);
        image.parentNode.classList.add("image-caption-wrapper");
    })
    loadMore();
});

function loadMore() {
    const loadMoreButton = document.querySelector(".articles-load-more-button");
    const loadingArticlesWrapper = document.querySelector(".articles--load-more");
    if (!loadMoreButton) return;
    if (!loadingArticlesWrapper) return;

    loadMoreButton.addEventListener("click", function (e) {
        e.preventDefault();
        const allHiddenArticles = document.querySelectorAll(".articles--load-more .article-card:not(.article-card--show-this)");
        if (allHiddenArticles.length === 0) {
            loadMoreButton.parentNode.classList.add("hide-this");
            return;
        }

        Array.from(allHiddenArticles)
            .slice(0, 3)
            .forEach(articleCart => articleCart.classList.add("article-card--show-this"));
        loadingArticlesWrapper.classList.add("articles--show-this");

        if (allHiddenArticles.length <= 3) loadMoreButton.parentNode.classList.add("hide-this");

    })
}